<div class="u-padding-medium">
  <div class="u-marginBottom-small">
    @if (data.hasAccess) {
      <h2 class="text-heading-lg u-marginBottom-2xsmall u-textAlign-center">
        <ng-container i18n="@@aiAnnouncementModal.title"
          >Get better outcomes with 10KC AI</ng-container
        >
      </h2>
      <p
        [ngStyle]="{ width: '500px' }"
        class="color-grey-300 u-textAlign-center u-margin-center"
      >
        <ng-container i18n="@@aiAnnouncementModal.description"
          >Get better outcomes with less manual work with 10KC AI. These
          features are in beta. Please share your feedback to help us
          improve.</ng-container
        >
      </p>
    } @else {
      <h2 class="text-heading-lg u-marginBottom-2xsmall u-textAlign-center">
        <ng-container i18n="@@aiAnnouncementModal.noAccess.title"
          >10KC AI Suite Beta Is Here</ng-container
        >✨
      </h2>
      <p
        [ngStyle]="{ width: '500px' }"
        class="color-grey-300 u-textAlign-center u-margin-center"
      >
        <ng-container i18n="@@aiAnnouncementModal.noAccess.description"
          >Elevate your program with intelligent new features designed to save
          you time and provide deeper insights.
        </ng-container>
      </p>
    }
  </div>
  <div class="u-marginBottom-small" fxLayout="row" fxLayoutGap="16px">
    <div fxFlex="calc(50% - 8px)">
      @for (feature of features; track $index; let index = $index) {
        <button
          [ngClass]="{
            'u-bg-gradient-to-bottom-right u-gradient-from-teal-light u-gradient-to-blue-light u-border-teal700':
              selectedIndex === index,
            'u-border-default': selectedIndex !== index,
          }"
          (click)="selectedIndex = index"
          class="u-borderRadius-button u-padding-small c-button bg-color-blue--hover-4 u-marginBottom-xsmall"
          fxLayout="row"
          fxLayoutAlign="start start"
          fxLayoutGap="16px"
        >
          <div fxFlex="24px">
            <mat-icon class="material-symbols-outlined">{{
              feature.iconName
            }}</mat-icon>
          </div>
          <div fxFlex="calc(100% - 40px)">
            <p class="u-marginBottom-2xsmall">
              <b>{{ feature.title }}</b>
            </p>
            <p class="color-grey-300 text-body-sm">{{ feature.description }}</p>
          </div>
        </button>
      }
    </div>
    <div
      [ngStyle]="{
        backgroundColor: backgroundColors[selectedIndex],
        height: '320px',
      }"
      class="u-borderRadius-card u-position-relative u-overflow-hidden"
      fxFlex="calc(50% - 8px)"
      fxLayout="row"
      fxLayoutAlign="center center"
    >
      <img
        [ngSrc]="backgroundImages[selectedIndex]"
        [ngStyle]="{
          right: '50%',
          top: '-40px',
          transform: 'translate(-50%, 0)',
          width: '320px',
        }"
        alt=""
        class="u-position-absolute"
        fill
      />
      <div
        [ngStyle]="{ height: '300px', width: '300px' }"
        class="u-borderRadius-button u-overflow-hidden"
      >
        <img
          [ngSrc]="gifUrls[selectedIndex]"
          alt=""
          class="u-width-100"
          height="300"
          priority
          width="300"
        />
      </div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
    @if (data.hasAccess) {
      <button
        (click)="trackFeature('dismiss'); closeDialog(false)"
        color="primary"
        fxFlex="1 0 1"
        i18n="@@global.tryLater"
        mat-stroked-button
      >
        Try later
      </button>
      <button
        (click)="trackFeature('redirect'); closeDialog(true)"
        color="primary"
        fxFlex="1 0 1"
        i18n="@@aiAnnouncementModal.tryItInPrograms"
        mat-raised-button
      >
        Try it in Programs
      </button>
    } @else {
      <button
        (click)="trackFeature('dismiss'); closeDialog(false)"
        color="primary"
        fxFlex="1 0 1"
        i18n="@@global.tryLater"
        mat-stroked-button
      >
        Try later
      </button>
      <a
        (click)="trackFeature('consent'); closeDialog(true)"
        color="primary"
        fxFlex="1 0 1"
        href="https://hs.tenthousandcoffees.com/ai-beta-consent"
        i18n="@@aiAnnouncementModal.joinBetaCta"
        mat-raised-button
        rel="noopener"
        target="_blank"
      >
        Join the Beta
      </a>
    }
  </div>
</div>
